import {initHeader} from './header';
import {initNav} from './section.cds2-complex-menu';
import {initSectionCds2ComplexDescription} from './section.cds2-complex-description';
import {initSectionCds2SliderWithTooltips} from './section.cds2-slider-with-tooltips';
import {initComplexHeader} from './section.cds2-complex-header-slideshow';
import {initFeatureSlider} from './section.cds2-feature-slider';
import {initBird} from './section.cds2-complex-layout';
import {initCds2Video} from './section.cds2-video';
import {initIconCards} from './section.cds2-icon-cards';
import {initFooter} from './footer';
import {initCards} from './section.cds2-cards';
import {initBanner} from './section.cds2-banner';
import {initSlideshowVariable} from './section.slideshow-variable';
import {initSchemeMap} from './section.cds2-scheme-map';
import {initChooserWithNews} from './section.chooser-with-news';
import {initApartmentCompilations} from './section.apartment-compilations';
import {initPromoPhoto} from './section.promo-photo-with-digits-list';
import {initSpotHeader} from './section.cds2-spot-header';
import {initSpotCards} from './section.cds2-spot-complex-cards';
import {initIndexPromo} from './section.promo-header-index';
import {initSpotInfrastructure} from './section.cds2-spot-infrastructure';
import {initComplexesList} from './section.complexes-list';
import {initEmployees} from './section.cds2-employees';
import {initCds2MapObject} from './section.cds2-map-objects';
import {initTabsWithDescription} from './section.tabs-with-description';
import {initEnMenu} from './nav';
import {initComplexesAndSpots} from './section.cds2-complexes-and-spots';
import {initApartmentCard} from './article.cds2-apartment-card';
import {initConstructionProgress} from './section.construction-progress';
import {initMortgageCalc} from './section.cds2-mortgage-calculator';
import {initTableTabs} from './section.cds2-table-tabs';
import {initTables} from './section.table';
import {initBankProgram} from './section.cds2-bank-program-heading';
import {initBanks} from './section.banks';
import {initCds2Parking} from './section.cds2-parking';
import {initCds2Chooser} from './section.cds2-chooser';
import {initCds2VideoLibrary} from './section.cds2-video-library';
import {initMortgageTabs} from './section.cds2-subsidized-mortgage-calculator';
import {initCds2Counter} from './section.cds2-counter';
import {firstScreenInit} from './section.cds2-first-screen';
import {initVideoBanner} from './section.cds2-video-banner';
import {initCarousel} from './section.cds2-carousel';

export const initComponents = () => {
	initHeader();
	initNav();
	initSectionCds2ComplexDescription();
	initSectionCds2SliderWithTooltips();
	initComplexHeader();
	initFeatureSlider();
	initBird();
	initCds2Video();
	initIconCards();
	initFooter();
	initCards();
	initBanner();
	initSlideshowVariable();
	initSchemeMap();
	initChooserWithNews();
	initApartmentCompilations();
	initPromoPhoto();
	initSpotHeader();
	initSpotCards();
	initIndexPromo();
	initSpotInfrastructure();
	initComplexesList();
	initEmployees();
	initCds2MapObject();
	initTabsWithDescription();
	initEnMenu();
	initComplexesAndSpots();
	initApartmentCard();
	initConstructionProgress();
	initMortgageCalc();
	initTableTabs();
	initTables();
	initBankProgram();
	initBanks();
	initCds2Parking();
	initCds2Chooser();
	initCds2VideoLibrary();
	initMortgageTabs();
	initCds2Counter();
	firstScreenInit();
	initVideoBanner();
	initCarousel();
};
